
import React from 'react';

import ReactDOM from 'react-dom';
import { Layout } from 'element-react';
import FeasComponents from '../render/FeasComponents.js'
 

import KeeVue from '../base/KeeVue.js'
 
export default class FsCard extends KeeVue {
	constructor(props) {
		super(props);

		this.state = {
			isShow: false,
			randId: this.getRandString(),

		}

	}

	componentWillMount() {
		var that = this;
		this.registComponent();

	}

	onCommand=(cmdName, item, po, thisForm, parentForm)=> {
		this.$emit("command", cmdName, item, po, thisForm, parentForm);
	}
	onChanged=(ret)=> {
		this.$emit("changed", ret);
	}

	render() {
		var style = JSON.parse(JSON.stringify(this.props.component.style));
		var showTitle =  this.props.component.cp.isShowTitle!==false||(window.isReport&&this.props.component.cp.title);
	 // console.log("this.props.keePage.name："+(this.props.keePage?this.props.keePage.name:''));
	 var appCode = this.getUrlParameter("appCode")
	  if(appCode&&appCode.indexOf("REPORT_")!=-1)
	  { 
		  showTitle = true;
	  }
		// 强制col的display为block
	 
		return ( 
			<div>
				<label className={`el-form-item__label`}
					style={{ 
						textAlign:this.props.component.cp.labelPosition!='top'?this.props.component.cp.labelPosition:'left',
						width: this.props.component.cp.labelPosition!='top'?((showTitle?this.props.component.cp.labelWidth+'px':'0px')):'100%',
						display:(showTitle?'block':'none'),
						// paddingLeft: '15px'
					}}>
					<span style={{color:'#EB2829'}}>{(this.props.component.cp.required===true?'*':'')}</span>{this.props.component.cp.title}
				</label>
				<div style={{
					width: '100%',
					// padding: '15px',
					boxSizing: 'border-box'
				}}>
					<div style={style} className="el-card is-always-shadow box-card"> 
						<div 
							className="el-card__body"
							style={{
								padding: '35px 10px'
							}}
						>
						{
							this.props.component.child && this.props.component.child.length > 0 ? <FeasComponents components={this.props.component.child} 
							query={this.props.query}
							keePage={this.props.keePage} 
							parentViewName={this.props.parentViewName} po={this.props.po} 
							thisForm={this.props.thisForm} parentForm={this.props.parentForm} 
							name={this.props.name} debug={this.props.debug}
							editable={this.props.editable}
							onchanged={this.onChanged}
							onCommand={this.onCommand}
							></FeasComponents> : window.isReport&&this.props.debug&&<div style={{width:'100%',textAlign:'center',lineHeight:'80px',color:'#666666'}}>拖拽组件到分组中</div>
						}
						</div>
					</div>
				</div>
			</div>

		);
	}
}
